import { RunningLineItem } from "./components/blocks/RunningLine";
import {
    culturQueerDomain,
    PathEnum,
    submitFilmLink,
    submitFrFilmLink,
} from "./i18n/locale-config";

export const footerLinks = (t: Function): { href: string; title: string }[] => [
    {
        href: "",
        title: t("faq"),
    },
    {
        href: "",
        title: t("contactUs"),
    },
    // {
    //     href: supportUsLink,
    //     title: t('supportUs'),
    // },
    // {
    //     href: becomeVolunteerLink,
    //     title: t('becomeVolunteer'),
    // },
];

export const socials = (t: Function): { href: string; title: string }[] => [
    {
        href: "https://www.facebook.com/imagenationMTL",
        title: t("Socials.facebook"),
    },
    {
        href: "https://www.instagram.com/imagenationmtl?igsh=ZmRoemxrcmNnOGJr",
        title: t("Socials.instagram"),
    },
    {
        href: "https://www.linkedin.com/company/imagenationmtl",
        title: t("Socials.linkedin"),
    },
    {
        href: "https://www.youtube.com/user/imagenationxx",
        title: t("Socials.youtube"),
    },
];

export const asideLinks = (
    t: Function,
    locale: string = "fr",
): {
    title: string;
    link?: string;
    items: { title: string; link: string; openInNewTab?: boolean }[];
}[] => [
    {
        title: t("about"),
        items: [
            { title: `${t("aboutIN")}`, link: PathEnum.About },
            { title: t("partners"), link: PathEnum.Partners },
            { title: t("insights"), link: PathEnum.Insights },
            {
                title: t("submit"),
                link: locale === "en" ? submitFilmLink : submitFrFilmLink,
                openInNewTab: true,
            },
            // { title: t('archives'), link: '/' }
        ],
    },
    {
        title: t("festival"),
        items: [
            { title: t("program"), link: PathEnum.Program },
            { title: t("allFilms"), link: PathEnum.Films },
            { title: t("schedule"), link: PathEnum.Schedule },
            // { title: t('events'), link: '/' },
            {
                title: t("interactiveCatalog"),
                link: PathEnum.InteractiveCatalog,
            },
        ],
    },
    {
        title: t("connexe"),
        link: PathEnum.Connexe,
        items: [
            // { title: t('series'), link: '/' },
            // { title: t('conversations'), link: '/' }
        ],
    },
    {
        title: t("competition"),
        items: [
            {
                title: t("films"),
                link: PathEnum.Films +
                    "?focuses=219f0040-b7d6-47ed-ac85-517f3974fbd5",
            },
            { title: t("jury"), link: PathEnum.Jury },
            { title: t("awards"), link: PathEnum.Awards },
        ],
    },
    // {
    //     title: t("media"),
    //     items: [
    //         { title: t("accreditation"), link: PathEnum.Accreditation },
    //         // { title: t('library'), link: '/' },
    //         // { title: t('press'), link: '/' },
    //     ],
    // },
    {
        title: t("info"),
        items: [
            { title: t("venues"), link: PathEnum.Venues },
            // { title: t('visitors'), link: '/' },
            {
                title: t("contact"),
                link: culturQueerDomain + locale + "/#questions",
                openInNewTab: true,
            },
        ],
    },
];

export const runningLineItems = (t: Function): RunningLineItem[] => [
    {
        type: "text",
        content: t("RunningLine.text1"),
        className: "text-xl lg:text-h5 uppercase font-bold",
    },
    {
        type: "text",
        content: t("RunningLine.text2"),
        className: "text-xl lg:text-h5 uppercase font-bold",
    },
];

export const staticFilters = (
    type?: "card" | "filters",
): { id: string; icon: string; name: { en: string; fr: string } }[] => [
    {
        id: "53a38b3b-849d-40cb-a719-0ea224f6c33b",
        icon: type === "card"
            ? "/img/icons/canada.svg"
            : "/img/focuses/made-in-canada.svg",
        name: {
            en: "Made au Canada",
            fr: "Made au Canada",
        },
    },
    {
        id: "d93cf2c4-ee03-4688-9a08-153f06918951",
        icon: type === "card"
            ? "/img/icons/quebec.svg"
            : "/img/focuses/queer-quebec.svg",
        name: {
            en: "Queerment Québec",
            fr: "Queerment Québec",
        },
    },
    {
        id: "219f0040-b7d6-47ed-ac85-517f3974fbd5",
        icon: type === "card"
            ? "/img/icons/competition.svg"
            : "/img/focuses/competition.svg",
        name: {
            en: "Competition",
            fr: "Compétition",
        },
    },
];

export const accountTabs = (
    t: Function,
): { label: string; link: string; path: string }[] => [
    {
        label: t("personalInformation"),
        link: PathEnum.Account,
        path: "Account",
    },
    { label: t("myTickets"), link: PathEnum.MyTickets, path: "MyTickets" },
    {
        label: t("orderHistory"),
        link: PathEnum.OrderHistory,
        path: "OrderHistory",
    },
    // { label: t('travelInfo'), link: PathEnum.TravelInfo, path: 'TravelInfo' },
    {
        label: t("accreditation"),
        link: PathEnum.Accreditation,
        path: "Accreditation",
    },
];

export const connexeFocusId = "0ba5bc15-8495-4e9e-b038-2c5a8d30f98a";
export const seriesFocusId = "89dfdb9e-9125-44fc-a4e2-b2c5fd2f587b";
